export default "__VITE_ASSET__tB2Zp4A5__"